import { render, staticRenderFns } from "./OrderClaims.vue?vue&type=template&id=73c30540&"
import script from "./OrderClaims.vue?vue&type=script&lang=js&"
export * from "./OrderClaims.vue?vue&type=script&lang=js&"
import style0 from "./OrderClaims.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports